/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from "react";
import { Form, InputGroup, Button } from "react-bootstrap";
import { TrashIcon } from "@heroicons/react/solid";
import * as S from "../../../../../../styles";

export interface IKanbanCardProps {
    onDelete?(): void;
    cardRef: any;
    title: string;
    titleColor?: string;
    attributeType: string;
    isRequired?: string;
    attributeOptions?: string;
    image?: string;
    style?: any;
    extraProps?: any;
    id?: string;
    value?: string;
    required?: boolean;
    placeholder?: string;
    onCompChange?(id: string, payload: any): void;
}

export const KanbanCard = (props: IKanbanCardProps) => {
    const {
        cardRef,
        title,
        titleColor,
        attributeType,
        attributeOptions,
        isRequired,
        image,
        value,
        placeholder,
        onDelete,
        onCompChange,
        style = {},
        extraProps = {},
        id
    } = props;
    const [textValue, setTextValue] = useState(value ?? "");
    const onChange = (id: string, e: any) => {
        setTextValue(e?.target?.value);
        onCompChange && onCompChange(id, e?.target?.value);
    };

    const _renderLabelIf = () => {
        if (title) {
            return (
                <S.FormLabel style={{ paddingLeft: "0px" }} color={titleColor}>
                    {title}
                    {isRequired && <sup style={{ color: "red" }}>*</sup>}
                </S.FormLabel>
            );
        }
        return null;
    };

    return (
        <div ref={cardRef} style={{ width: "100%", paddingLeft: "15px" }}>
            <Form.Group id={id} className="mb-4">
                {_renderLabelIf()}
                <InputGroup>
                    <Form.Control
                        // className="formcontrol shadow-none"
                        value={textValue}
                        onChange={onChange.bind(null, id)}
                        required={isRequired}
                        type="text"
                        placeholder={placeholder}
                    />
                    <Button variant="outline-secondary" onClick={onDelete}>
                        <TrashIcon className="icon icon-xs text-black me-2" />
                    </Button>
                </InputGroup>
            </Form.Group>
        </div>
    );
};

KanbanCard.defaultProps = {
    required: false
};
